<template>
  <div style="height:calc(100% - 50px);margin-top:50px;">
    <!--侧边栏-->
    <div class="leftBar">
      <v-avatar color="transparent" size="80" class="mt-10">
        <v-img :src="$store.state.avatar" style="width:100%;height:100%;"></v-img>
      </v-avatar>
      <p style="font-size:18px;" class="mt-5 mb-6">{{$store.state.nickName}}</p>
      <v-list dense>
        <v-list-item-group v-model="$store.state.homeLeftBarSelectedIndex" color="primary">
          <!--影像管理栏取消-->
          <v-list-item :disabled="$store.state.homeLeftBarSelectedIndex === index" v-show="item.text !== '影像管理'" v-for="(item, index) in leftBarTitleList" :key="index" class="leftBar-title mt-3">
            <p class="pl-7"><span v-html="item.icon" class="iconfontFamily mr-4"></span>{{item.text}}</p>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
    <!--主要区域 ,'height':$store.state.homeLeftBarSelectedIndex === 2 ? 'calc(100vh - 60px)' : '100%'-->
    <div :style="{'padding':$store.state.homeLeftBarSelectedIndex === 0 ? '0 20px' : '0'}" class="main">
      <main-home v-if="$store.state.homeLeftBarSelectedIndex === 0"></main-home>
      <main-create v-if="$store.state.homeLeftBarSelectedIndex === 1"></main-create>
      <main-creation-manage v-if="$store.state.homeLeftBarSelectedIndex === 2"></main-creation-manage>
      <main-image-library v-if="$store.state.homeLeftBarSelectedIndex === 3"></main-image-library>
      <main-user-center v-if="$store.state.homeLeftBarSelectedIndex === 4"></main-user-center>

      <main-notice v-if="$store.state.homeLeftBarSelectedIndex === 999"></main-notice>


    </div>
  </div>

</template>

<script>
import MainHome from './main/MainHome';
import MainCreate from './main/MainCreate';
import MainCreationManage from './main/MainCreationManage';
import MainImageLibrary from './main/MainImageLibrary';
import MainUserCenter from './main/MainUserCenter';
import MainNotice from './main/MainNotice';
export default {
  name: 'Home',
  components: {
    MainHome,MainCreate,MainCreationManage,MainImageLibrary,MainUserCenter,MainNotice
  },
  data(){
    return{
      leftBarTitleList:[
        {text:"首页",icon:"&#xe609;"},
        {text:"内容创作",icon:"&#xe621;"},
        {text:"创作管理",icon:"&#xe614;"},
        {text:"影像管理",icon:"&#xe61c;"},
        {text:"个人中心",icon:"&#xe616;"},
      ],


    }


  },
  watch:{
    //监听切换侧边栏，修改路由参数
    "$store.state.homeLeftBarSelectedIndex":{
      handler:function(newVal,oldVal){
        let url = document.location.toString();
        let arrObj = url.split("?");
        switch(newVal){
          case 0:{
            history.pushState('', '', arrObj[0] + "?goHome=goHome");
            break;
          }
          case 1:{
            history.pushState('', '', arrObj[0] + "?goHome=goCreate");
            break;
          }
          case 2:{
            history.pushState('', '', arrObj[0] + "?goHome=goCreationManage");
            break;
          }
          case 3:{
            history.pushState('', '', arrObj[0] + "?goHome=goImageLibrary");
            break;
          }
          case 4:{
            history.pushState('', '', arrObj[0] + "?goHome=goUserCenter");
            break;
          }


        }



      }
    }
  },
  methods:{

    //判断是否跳转页面
    pageJump(){
      // //url里是否有需要进行页面跳转的参数
      // //intoNotice，如有进入通知公告栏
      // //intoCreationManage，进入创作管理
      // //intoUserCenter，进入用户中心
      // let url = document.location.toString();
      // let arrObj = url.split("?");
      // if (arrObj.length > 1) {
      //   let arrPara = arrObj[1].split("&");
      //   let arr;
      //   for (let i = 0; i < arrPara.length; i++) {
      //     arr = arrPara[i].split("=");
      //     console.log(arr)
      //     if (arr != null && arr[0] === "intoNotice") {
      //       //有notice参数，需要跳转到通知公告页面
      //       this.$store.state.homeLeftBarSelectedIndex = 999;
      //       this.$store.state.newNotice = false;
      //       //修改url但是不刷新
      //       history.pushState('', '', arrObj[0]);
      //     }
      //     else if(arr != null && arr[0] === "intoCreationManage"){
      //       //有creationManage参数，跳转到创作管理
      //       this.$store.state.homeLeftBarSelectedIndex = 2;
      //       //修改url但是不刷新
      //       history.pushState('', '', arrObj[0]);
      //     }
      //     else if(arr != null && arr[0] === "intoUserCenter"){
      //       //有creationManage参数，跳转到创作管理
      //       this.$store.state.homeLeftBarSelectedIndex = 4;
      //       //修改url但是不刷新
      //       history.pushState('', '', arrObj[0]);
      //     }
      //
      //
      //   }
      // }
      // else{
      //   //无参数，进入首页
      //   this.$store.state.homeLeftBarSelectedIndex = 0;
      // }
      //

      if(this.$route.query.goHome !== undefined){
        //有goHome参数
        switch(this.$route.query.goHome){
          case "goHome":{
            //有传参进入公告页的情况
            if(this.$route.query.intoNotice !=undefined){
              this.$store.state.homeLeftBarSelectedIndex = 999;
              // this.$store.state.newNotice = false;
            }
            else{
              this.$store.state.homeLeftBarSelectedIndex = 0
            }
            break;
          }
          case "goCreate":{
            this.$store.state.homeLeftBarSelectedIndex = 1
            break;
          }
          case "goCreationManage":{
            this.$store.state.homeLeftBarSelectedIndex = 2
            break;
          }
          case "goImageLibrary":{
            this.$store.state.homeLeftBarSelectedIndex = 3
            break;
          }
          case "goUserCenter":{
            this.$store.state.homeLeftBarSelectedIndex = 4
            break;
          }
        }
      }
      else{
        //无goHome参数，侧边栏第一项
        this.$store.state.homeLeftBarSelectedIndex = 0
        history.pushState('', '', document.location.toString() + "?goHome=goHome");
      }












    },




  },
  mounted(){
    this.pageJump()
  }


}
</script>

<style scoped>
.leftBar{
  position:fixed;
  width:200px;
  height:100%;
  background:#ffffff;
  text-align:center;
  float:left;
}
.leftBar-title{
  height:50px;
  border-left:5px solid transparent;
  font-size:18px;
  cursor:pointer;
}
.leftBar-title.v-list-item--active{
  color:#000000;
  border-left-color: #1E3A8A;
  background:rgba(30, 58, 138, 0.1);
}

.main{
  width:calc(100% - 200px);
  height:100%;
  background:#F9F9F9;
  float:right;
  overflow-x:auto;
}


</style>
